import React, {useEffect, useState, useCallback} from 'react'
import { useNavigate } from 'react-router'
import { Link } from 'react-router-dom'
import { Row, Col, Card, ProgressBar, Badge, Alert } from 'react-bootstrap'
import * as IconsBi from "react-icons/bi";
import * as IconsBs from "react-icons/bs";
import * as IconsFa from "react-icons/fa";
import * as IconsFi from "react-icons/fi";
import * as IconsMd from "react-icons/md";
import * as IconsTb from "react-icons/tb";
import * as IconsGi from "react-icons/gi";
import { numberWithCommas } from 'components/common/Config';

import { AxiosOperator as Axios, AxiosErrorHandling } from "connection/Axios"
import { useForm, Controller, useFieldArray } from "react-hook-form";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { toast } from 'react-toastify';
import Select from 'react-select';
import { genders, yesNoOptions, selectBaseStyles, selectInvalidStyles, requiredIndicator, toPersianNumber } from 'components/common/Config';
import store from 'store/store';
import MyFormWrapper from 'components/common/MyFormWrapper'


const fields1_prefix = 'dashboard-scoring-pattern'
const fields1 = [
    {
        id: 101,
        type: 'select',
        name: 'title',
        visibility: true,
        rules: ['required'],
        dir: 'rtl',
        bs_grid: [4],
        className: 'mb-3',
        options: [],
        multiple: false,
        selectAll: false,
    },
]


function Admin(props) {
    const data = props?.data
    // const pattern = props?.pattern
    const patterns = props?.patterns
    const tags = props?.tags
    console.log('props**:',props)
    const navigate = useNavigate()
    const state = store.getState()

    const [pattern, setPattern] = useState(props?.pattern);
    const [min, setMin] = useState(null);
    const [max, setMax] = useState(null);
    const [serverErrors, setServerErrors] = useState(null)
    const [doingSubmit, setDoingSubmit] = useState(false)
    const [patternsData, setPatternsData] = useState([])
    const [patternsDataOptions, setPatternsOptions] = useState([])

    const [, updateState] = useState()
    const forceUpdate = useCallback(() => updateState({}), [])

    useEffect(() => {
        if(pattern?.media?.length > 0) {
            setMin(Math.min(...pattern?.media?.map(o => o.score)))
            setMax(Math.max(...pattern?.media?.map(o => o.score)))
        }
        
    }, [pattern])

    useEffect(() => {
        let patterns_h = []
        patterns.map(p => {
            patterns_h.push({
                value: p.id,
                label: toPersianNumber(p.title),
            })
        })

        setPatternsOptions(patterns_h)
        fields1.find(item => item.name === 'title').options = patterns_h
        
    }, [patterns])


    const schema = yup.object().shape({
        title: yup.string().required('وارد کردن مقدار الزامیست'),
    });

    const { control, register, handleSubmit, formState: { errors }, setError, reset, getValues } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = (data) => {
        setPattern(patterns?.find(p => parseInt(p.id) === parseInt(data.title)))
    }

    const [selectedTags, setSelectedTags] = useState([]);
    // const [filterTag, setFilterTag] = useState(null);
    const handleTagClick = (tag) => {
        let newSelectedTags
        if(selectedTags.includes(tag?.value))
            newSelectedTags = selectedTags.filter(t => t !== tag?.value)
        else
            newSelectedTags = [...selectedTags, tag?.value]

        setSelectedTags(newSelectedTags)
    };

    const filterByTags = (items, tags) => {
        return items.filter(item => {
            const itemTags = item.media.tags.split(',');
            return tags.every(tag => itemTags.includes(tag));
        });
    }


    const [filteredMedia, setFilteredMedia] = useState([]);
    useEffect(() => {
        if(selectedTags.length > 0) {
            let filteredMedia_h = pattern?.media.filter(item => {
                if(item.media.tags !== null) {
                    const itemTags = item.media.tags.split(',').map(tag => parseInt(tag));
                    return selectedTags.every(tag => itemTags.includes(parseInt(tag)));
                }
            });
            setFilteredMedia(filteredMedia_h)
        }
    }, [selectedTags])

    const handleSelectChange = (selected) => {
        console.log('selected:',selected)
        setPattern(patterns?.find(p => parseInt(p.id) === parseInt(selected.value)))
    }


    return (
        <>
            <Card
                bg="light"
                text="primary"
            >
                <Card.Body>
                    <Row>
                        <Col md="6">
                            <label className="mb-2">الگوی رتبه‌بندی</label>
                            <Select
                                options={patternsDataOptions}
                                // value={selectedOption}
                                onChange={handleSelectChange}
                                placeholder="یک گزینه انتخاب کنید..."
                                // isClearable={true}
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Row style={{display:'flex', justifyContent:'space-between', alignItems:'stretch'}}>
                <h4 className="text-success">
                    <span>الگوی رتبه‌بندی: </span>
                    {
                        toPersianNumber(pattern?.title)
                    }
                </h4>
                <h6 className="text-primary">
                    <span style={{fontWeight:'normal'}}>بازه نتایج </span>
                    <span style={{fontWeight:'bold'}}>
                    {
                        toPersianNumber(pattern?.start)
                    }
                    </span>
                    <span style={{fontWeight:'normal'}}> تا </span>
                    <span style={{fontWeight:'bold'}}>
                    {
                        toPersianNumber(pattern?.end)
                    }
                    </span>
                    &nbsp;
                    {
                        pattern?.rating_date_sh?.length > 0 &&
                        <>
                            &nbsp;
                            -
                            &nbsp;
                            <span style={{fontWeight:'normal'}}>زمان رتبه‌بندی </span>
                            <span style={{fontWeight:'bold'}}>
                            {
                                toPersianNumber(pattern?.rating_date_sh)
                            }
                            &nbsp;
                            {
                                toPersianNumber(pattern?.rating_time_sh)
                            }
                            </span>
                        </>
                    }
                </h6>

                <div>
                <label>فیلتر براساس تگ: </label>
                {
                    tags?.map((tag,tag_index) => {
                        return (
                            <Badge
                                key={tag_index}
                                className="m-2" 
                                bg={selectedTags.includes(tag.value) ? 'success' : 'secondary'}
                                onClick={() => handleTagClick(tag)}
                                style={{ cursor: 'pointer' }}
                            >
                                {tag.label}
                            </Badge>)
                    })
                }
                </div>
                    
                {
                    pattern?.media?.length > 0
                    ?
                        selectedTags?.length < 1
                        ?
                        <Row className="d-flex align-items-stretch">
                        {
                            pattern?.media?.map((item,index) => (
                                <Col key={index} md={3} className="mb-4 d-flex">
                                    <Card
                                        bg="light"
                                        text="primary"
                                    >
                                        <Card.Body>
                                            <div style={{fontFamily:'Vazir-Farsi'}}>
                                                <div style={{float:'right',width:'48%'}}>
                                                    <Badge bg="" style={{borderRadius:'10px', height:'40px', width:'120px', backgroundColor:'#e8faf8'}}>
                                                        {/* <IconsFa.FaMedal style={{fontSize:'40px', color:'#17d1bd'}} /> */}
                                                        <span style={{fontSize:'30px', color:'#17d1bd', lineHeight:'30px'}}>
                                                            <IconsGi.GiPodium />
                                                            {" "}
                                                            {item.rank}
                                                        </span>
                                                    </Badge>
                                                </div>
                                                <div style={{float:'left',width:'48%',textAlign:'left'}}>
                                                    <Badge bg="" style={{borderRadius:'10px', height:'40px', width:'120px', backgroundColor:'#edf1fc'}}>
                                                        {/* <IconsFa.FaMedal style={{fontSize:'40px', color:'#17d1bd'}} /> */}
                                                        <span style={{fontSize:'30px', color:'#4e73e5', lineHeight:'30px'}}>
                                                            <IconsBs.BsSpeedometer2 />
                                                            {" "}
                                                            <span dir="ltr">{item.score}</span>
                                                        </span>
                                                    </Badge>
                                                </div>
                                                <div className="w-100"></div>
                                            </div>
                                            <div style={{clear:'both',marginBotton:'30px'}} className="mb-5"></div>
                                            <div>
                                                <p style={{textAlign:'center',fontWeight:'bold',fontSize:'25px',lineHeight:'60px'}}>
                                                    {
                                                        state?.user?.type?.includes('operator')
                                                        ?
                                                        <a href={"o/media/" + item.media?.id + "/details"} target="_blank" rel="noreferrer">
                                                            {item.media?.name_fa}
                                                        </a>
                                                        :
                                                        <span style={{color:'#000'}}>
                                                            {item.media?.name_fa}
                                                        </span>
                                                    }
                                                </p>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                        }
                        </Row>
                        :
                        <Row className="d-flex align-items-stretch">
                            {
                                filteredMedia?.map((item,index) => (
                                    <Col key={index} md={3} className="mb-4 d-flex">
                                        <Card
                                            bg="light"
                                            text="primary"
                                        >
                                            <Card.Body>
                                                <div style={{fontFamily:'Vazir-Farsi'}}>
                                                    <div style={{float:'right',width:'48%'}}>
                                                        <Badge bg="" style={{borderRadius:'10px', height:'40px', width:'120px', backgroundColor:'#e8faf8'}}>
                                                            {/* <IconsFa.FaMedal style={{fontSize:'40px', color:'#17d1bd'}} /> */}
                                                            <span style={{fontSize:'30px', color:'#17d1bd', lineHeight:'30px'}}>
                                                                <IconsGi.GiPodium />
                                                                {" "}
                                                                {index+1}
                                                                <span style={{fontSize:'14px'}}>({item.rank})</span>
                                                            </span>
                                                        </Badge>
                                                    </div>
                                                    <div style={{float:'left',width:'48%',textAlign:'left'}}>
                                                        <Badge bg="" style={{borderRadius:'10px', height:'40px', width:'120px', backgroundColor:'#edf1fc'}}>
                                                            {/* <IconsFa.FaMedal style={{fontSize:'40px', color:'#17d1bd'}} /> */}
                                                            <span style={{fontSize:'30px', color:'#4e73e5', lineHeight:'30px'}}>
                                                                <IconsBs.BsSpeedometer2 />
                                                                {" "}
                                                                <span dir="ltr">{item.score}</span>
                                                            </span>
                                                        </Badge>
                                                    </div>
                                                    <div className="w-100"></div>
                                                </div>
                                                <div style={{clear:'both',marginBotton:'30px'}} className="mb-5"></div>
                                                <div>
                                                    <p style={{textAlign:'center',fontWeight:'bold',fontSize:'25px',lineHeight:'60px'}}>
                                                        {
                                                            state?.user?.type?.includes('operator')
                                                            ?
                                                            <a href="11" target="_blank">
                                                                {item.media?.name_fa}
                                                            </a>
                                                            :
                                                            <span style={{color:'#000'}}>
                                                                {item.media?.name_fa}
                                                            </span>
                                                        }
                                                    </p>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))
                            }
                        </Row>
                    :
                    "رکوردی ثبت نشده است."
                }
            </Row>
        </>
    )
}

export default Admin;